import { render, staticRenderFns } from "./Register1.vue?vue&type=template&id=944d0fc6&"
import script from "./Register1.vue?vue&type=script&lang=js&"
export * from "./Register1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports